import { render, staticRenderFns } from "./teacherWishlistForm.vue?vue&type=template&id=071f0bcc&"
import script from "./teacherWishlistForm.vue?vue&type=script&lang=js&"
export * from "./teacherWishlistForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherWishlistForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports